module.exports = __webpack_public_path__ + "img/logo-pmu-55280d.png";


//////////////////
// WEBPACK FOOTER
// ./book/src/assets/img/logo-pmu.png
// module id = 651
// module chunks = 0